import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store/store";
import { GroceryListItem } from "../../components/groceryList/groceryList.types";


interface InitialState {
    groceryListItems: GroceryListItem[];
    groceryListId: string | null;
}

const initialState: InitialState = {
    groceryListItems: [],
    groceryListId: null
};

export const createGroceryListSlice = createSlice({
    name: "groceryList",
    initialState,
    reducers: {
        setGroceryListItems: (state, action: PayloadAction<GroceryListItem[]>) => {
            state.groceryListItems = action.payload;
        },
        setGroceryListItemsAndIngredientsList: (state, action: PayloadAction<{groceryListItems: GroceryListItem[], ingredientsList: any}>) => {
            state.groceryListItems = action.payload.groceryListItems;
        },
        setGroceryListId: (state, action: PayloadAction<string>) => {
            state.groceryListId = action.payload;
        },
    },

});


export const { setGroceryListItems, setGroceryListItemsAndIngredientsList, setGroceryListId } = createGroceryListSlice.actions;

export const groceryListItemsSelector = ((state: RootState) => state.groceryList.groceryListItems);
export const groceryListIdSelector = ((state: RootState) => state.groceryList.groceryListId);


export default createGroceryListSlice.reducer;